import { memo } from 'react';

import { Radio } from 'antd';
import type { RadioGroupProps } from 'antd';
import cn from 'classnames';

import cls from './input-radio-group.module.css';

interface InputRadioGroupProps extends RadioGroupProps {
    isBlock?: boolean;
}

export const InputRadioGroup = memo((props: InputRadioGroupProps) => {
    const { className, isBlock, ...radioGroupProps } = props;

    return (
        <Radio.Group
            {...radioGroupProps}
            className={cn(className, cls.root, { [cls.block]: isBlock })}
        />
    );
});

InputRadioGroup.displayName = 'InputRadioGroup';
